/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferSupplierSelection} from "./offerSupplierSelection.zod";

export const OfferCatalogBlock = zod
  .object({
    blockId: zod.uuid(),
    blockType: zod.enum(["CATALOG_ITEM"]),
    catalogItemId: zod.uuid(),
    kind: zod.enum(["MATERIAL", "SERVICE"]),
    quantity: zod
      .number()
      .nullable()
      .describe(
        "Authored display quantity. Null means implicit effective sold quantity one for calculation and remains null here. Positive fractions retain their value. Explicit zero or negative values never default to one and block progression.",
      ),
    remembered: zod.boolean(),
    selectedSupplierOffers: zod.array(OfferSupplierSelection),
  })
  .describe(
    "Authored identities only, not caller prices. A newly authored catalog block or changed sold identity\/kind requires an actual Engineering description in the document language, for SIMPLE or composite Material or Service, even with null quantity or empty supplier choices. No name or other-language fallback is allowed. Retained selections survive language changes; missing localized descriptions produce located SOURCE_MISSING and unavailable affected prices until repaired. Customer successors preserve repairable copied references; Template opening is new admission. Newly authored or changed Customer Offer DRAFT supplier selections are empty and fully unresolved, or nonempty with complete distinct SIMPLE-leaf coverage; nonempty partial coverage is rejected. Unchanged previously valid selections affected by source drift remain repairable issues. Positive progression requires a positive effective quantity (one for authored null) and valid coverage. MOQ is informational. Remembering controls Template opening; Customer successors preserve every authored input value.",
  );

export type OfferCatalogBlock = zod.input<typeof OfferCatalogBlock>;
export type OfferCatalogBlockOutput = zod.output<typeof OfferCatalogBlock>;
